"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pitOperationColumnPropsFullScreen = exports.pitOperationColumnProps = void 0;
const constants_1 = require("utils/constants");
exports.pitOperationColumnProps = [
    {
        show: true,
        field: 'pit_name',
        title: 'Pit',
        width: '200',
        filter: 'text',
    },
    {
        show: true,
        field: 'contractor_name',
        title: 'Contractor',
        width: '250',
        filter: 'text',
    },
    {
        show: true,
        field: 'area_name',
        title: 'Area',
        width: '200',
        filter: 'text',
    },
    {
        show: true,
        field: 'seam_name',
        title: 'Seam',
        width: '200',
        filter: 'text',
    },
    {
        show: true,
        field: 'brand_name',
        title: 'Coal Brand',
        width: '200',
        filter: 'text',
    },
    {
        show: true,
        field: 'excavator_no',
        title: 'Excavator',
        width: '200',
        filter: 'text',
    },
    {
        show: true,
        field: 'checkpoint_name',
        title: 'Pos',
        width: '200',
        filter: 'text',
    },
    {
        show: true,
        field: 'modified_date',
        title: 'Modified Date',
        width: '220',
        filter: 'date',
        format: `${constants_1.formatGridDate.ddMMYYYY} ${constants_1.formatGridDate.hhMM}`,
    },
    {
        show: true,
        field: 'modified_by',
        title: 'Modified By',
        width: '180',
        filter: 'text',
    },
];
exports.pitOperationColumnPropsFullScreen = [
    {
        show: true,
        field: 'pit_name',
        title: 'Pit',
        width: 'auto',
        filter: 'text',
    },
    {
        show: true,
        field: 'contractor_name',
        title: 'Contractor',
        width: '250',
        filter: 'text',
    },
    {
        show: true,
        field: 'area_name',
        title: 'Area',
        width: 'auto',
        filter: 'text',
    },
    {
        show: true,
        field: 'seam_name',
        title: 'Seam',
        width: 'auto',
        filter: 'text',
    },
    {
        show: true,
        field: 'brand_name',
        title: 'Coal Brand',
        width: 'auto',
        filter: 'text',
    },
    {
        show: true,
        field: 'excavator_no',
        title: 'Excavator',
        width: 'auto',
        filter: 'text',
    },
    {
        show: true,
        field: 'checkpoint_name',
        title: 'Pos',
        width: 'auto',
        filter: 'text',
    },
    {
        show: true,
        field: 'modified_date',
        title: 'Modified Date',
        width: '220',
        filter: 'date',
        format: `${constants_1.formatGridDate.ddMMYYYY} ${constants_1.formatGridDate.hhMM}`,
    },
    {
        show: true,
        field: 'modified_by',
        title: 'Modified By',
        width: '180',
        filter: 'text',
    },
];
